import { AbsenceType } from "../../API";
import { TimeOffEnum } from "../../lib/types/absences";

export const validTimeOff: string[] = [
  TimeOffEnum.Approved,
  TimeOffEnum.Pending,
];

export const isValidTimeOff = (status: string | null = "") =>
  validTimeOff.includes(status ?? "");

export const absenceTypeOptions = [
  { label: "Select Absence Type", value: "", disabled: true },
  ...Object.values(AbsenceType).map((type) => ({
    label: type.slice(0, 1).toUpperCase() + type.slice(1).toLowerCase(),
    value: type,
  })),
];
